import { Theme } from '@mui/material';

export const getSpacingNumber = (theme: Theme, arg: number) =>
  Number(theme.spacing(arg).replace('px', ''));
